import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProcedureModalPage } from './procedure-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ProcedureModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ProcedureModalPage]
})
export class ProcedureModalPageModule {}
